module.exports = __webpack_public_path__ + "494cd07c/img/rename-icon.de4e673d.svg";